const KANA_NAME_REGEX = /^[ぁ-ゔゞァ-・ヽヾ゛゜ーＡ-Ｚａ-ｚ]+$/
const KANA_NICKNAME_REGEX = /^[ぁ-ゔゞァ-・ヽヾ゛゜ーＡ-Ｚａ-ｚ\u3000]*[ぁ-ゔゞァ-・ヽヾ゛゜ーＡ-Ｚａ-ｚ][ぁ-ゔゞァ-・ヽヾ゛゜ーＡ-Ｚａ-ｚ\u3000]*$/

export const KANA_NAME_INPUT_PATTERN = '[ぁ-ゔゞァ-・ヽヾ゛゜ーＡ-Ｚａ-ｚ]+'
export const KANA_NAME_HELPER_TEXT = '全角ひらがな・全角カタカナ・全角英字'
export const KANA_NAME_ERROR_TEXT = '全角ひらがな・全角カタカナ・全角英字で入力してください'

export const validateHiraganaKatakana = (text = '') => {
    return KANA_NAME_REGEX.test(text)
}

/** True only for null, undefined, or empty string (whitespace-only is not treated as empty). */
const isEmptyOptional = text => text == null || String(text) === ''

const isWhitespaceOnly = text => String(text).replace(/[\s\u3000]/g, '') === ''

/** Empty string, null, or undefined is valid; otherwise same rules as validateHiraganaKatakana. */
export const validateHiraganaKatakanaOptional = (text = '') => {
    const s = text == null ? '' : String(text)
    if (isEmptyOptional(text)) return true
    if (isWhitespaceOnly(s)) return false
    return !!validateHiraganaKatakana(s)
}

/** Empty string, null, or undefined is valid; otherwise kana name rules with zenkaku space allowed. */
export const validateKanaNicknameOptional = (text = '') => {
    const s = text == null ? '' : String(text)
    if (isEmptyOptional(text)) return true
    if (isWhitespaceOnly(s)) return false
    return KANA_NICKNAME_REGEX.test(s)
}

export const validateKanjiHiraganaKatakana = (text = '') => {
    if (text.split(' ').join('') === '') return false
    let result = true
    text.split('').forEach(char => {
        if (
            !char.match('^[一-龠ぁ-ゔゞァ-・ヽヾ゛゜ー]+$') &&
            !char.match(
                /([\u{3005}\u{3007}\u{303b}\u{3400}-\u{9FFF}\u{F900}-\u{FAFF}\u{20000}-\u{2FFFF}][\u{E0100}-\u{E01EF}\u{FE00}-\u{FE02}]?)/mu
            )
        ) {
            result = false
        }
    })
    return result
}

/** Empty string, null, or undefined is valid; otherwise same rules as validateKanjiHiraganaKatakana. */
export const validateKanjiHiraganaKatakanaOptional = (text = '') => {
    const s = text == null ? '' : String(text)
    if (isEmptyOptional(text)) return true
    return validateKanjiHiraganaKatakana(s)
}

export const validateNumbers = (text = '') => {
    return text.match('^[0-9]*$')
}
export const validateEmail = (text = '') => {
    const emailRegex = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9]+([.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,3}$/)
    if (emailRegex.test(text)) {
        return true
    }
    return false
}
export const validatePhone = (text = '') => {
    return text.match(/^[0-9]{9,11}$/)
}
export const validatePassword = (text = '') => {
    return text.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{10,}$/)
}

export const validateEmpCode = (text = '') => {
    const regex = /^[0-9\b]+$/
    return regex.test(text)
}

/** Empty string, null, or undefined is valid; otherwise digits only (same as validateEmpCode). */
export const validateDigitsOnlyOptional = (text = '') => {
    const s = text == null ? '' : String(text)
    if (isEmptyOptional(text)) return true
    return validateEmpCode(s)
}